import { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import AllAutoRequestsDrawer from "./AllRequestsDrawer";

const CustomTooltip = ({ active, payload, label, longMonth }: any) => {
  const isVisible = active && payload && payload.length;
  return (
    <div
      className="custom-tooltip bg-white p-2 rounded-md shadow-xs"
      style={{ visibility: isVisible ? "visible" : "hidden" }}
    >
      {isVisible && (
        <>
          <p className="label">{`${label}`}</p>
          <p className="intro">{longMonth}</p>
          <p className="desc">Total requests: {payload[0].value}</p>
        </>
      )}
    </div>
  );
};

const renderCustomizedLabel = (props: any) => {
  const { x, y, width, value } = props;
  const radius = 10;

  return (
    <g>
      <text
        x={x + width / 2}
        y={y - radius}
        fill="#323232"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {value}
      </text>
    </g>
  );
};

const MainChart = ({
  isAnimationActive = true,
  defaultIndex,
  data,
  dateRange,
}: {
  isAnimationActive?: boolean;
  defaultIndex?: any;
  data?: any;
  dateRange?: any;
}) => {
  const [detailsModal, setDetailsModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>(null);

  function monthOnClick(e: any) {
    setDetailsModal(true);
    setSelected(e.payload);
  }
  return (
    <div className="w-full" style={{ height: "500px" }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{
            top: 40,
            right: 0,
            left: 0,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip
            content={CustomTooltip}
            isAnimationActive={isAnimationActive}
            defaultIndex={defaultIndex}
          />
          <Bar
            dataKey="count"
            fill="#184377"
            barSize={20}
            onClick={monthOnClick}
          >
            <LabelList dataKey="count" content={renderCustomizedLabel} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      {detailsModal && (
        <AllAutoRequestsDrawer
          title="Requests by Month"
          isVisible={detailsModal}
          setVisible={setDetailsModal}
          selected={selected}
          startDate={selected?.startDate}
          endDate={selected?.endDate}
        />
      )}
    </div>
  );
};

export default MainChart;
